"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __importStar(require("lodash"));
function AddConfigMethod(prototype, method) {
    prototype[method] = function () {
        var cfgX = this;
        var config = cfgX._config;
        if (config && config[method] && typeof config[method] === "function") {
            if (!cfgX.configs.hasOwnProperty("_" + method)) {
                cfgX.configs["_" + method] = _.clone(cfgX._config[method]());
            }
            return cfgX.configs["_" + method];
        }
    };
}
function buildConfig(env, map) {
    var CfgX = /** @class */ (function () {
        function CfgX() {
            this.configs = {};
            this.envConfigs = map;
            this.updateConfigEnv(env);
        }
        CfgX.prototype.updateConfigEnv = function (newEnv) {
            this._env = newEnv;
            this._config = this.envConfigs[newEnv];
            this.configs = {};
        };
        CfgX.prototype.addEnvironment = function (envName, cfg) {
            if (this.envConfigs == undefined) {
                this.envConfigs = {};
            }
            this.envConfigs[envName] = cfg;
        };
        return CfgX;
    }());
    var c = map[env];
    var pp = CfgX.prototype;
    for (var propName in c) {
        if (typeof c[propName] === "function") {
            AddConfigMethod(pp, propName);
        }
    }
    var cfgX = new CfgX();
    return cfgX;
}
exports.buildConfig = buildConfig;
